import React from 'react';
import { Loader2 } from 'lucide-react';

interface SocialLoginButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

export function SocialLoginButton({
  icon,
  label,
  onClick,
  loading = false,
  disabled = false,
  className = ''
}: SocialLoginButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading || disabled}
      className={`w-full flex items-center justify-center gap-3 px-4 py-2.5 bg-white dark:bg-[#1E293B] border border-[#A6A6A6] dark:border-[#333840] rounded-lg text-sm font-medium text-[#1C1C1C] dark:text-[#E8E8E8] hover:bg-gray-50 dark:hover:bg-[#182438] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#003366] dark:focus:ring-[#2962FF] disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${className}`}
    >
      {loading ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        icon
      )}
      {label}
    </button>
  );
}
